<div class="main-page cockpit consultas">
  <div class="container-fluid">
    <div class="row align-items-center">
      <div class="col-12 my-2">
        <h1>Grid</h1>
      </div>
    </div>

    <div class="wrapper grid-summary">
      <div class="grid-summary-cards">
        <mat-card class="grid-summary-card">
          <div class="details">
            <mat-icon class="grid-summary-icon">directions_car</mat-icon>
            <div class="desc">{{ totalElements }} veículo(s) no total</div>
          </div>
        </mat-card>
      </div>
    </div>

    <div class="wrapper grid-filters">
      <mat-form-field appearance="outline" class="grid-search">
        <mat-label>{{
          exibirEnderecoNoGrid
            ? "Buscar placa, frota, empresa, motorista, evento ou endereço"
            : "Buscar placa, frota, empresa, motorista ou evento"
        }}</mat-label>
        <mat-icon matPrefix class="grid-search-icon">search</mat-icon>
        <input
          matInput
          [value]="searchTerm"
          (input)="onSearchChange($any($event.target).value)"
        />
      </mat-form-field>

      <mat-form-field appearance="outline" class="grid-status-filter">
        <mat-label>Status</mat-label>
        <mat-select
          [value]="statusFilter"
          (selectionChange)="onStatusFilterChange($event.value)"
        >
          <mat-option value="all">Todos</mat-option>
          <mat-option value="Online">Online</mat-option>
          <mat-option value="Offline">Offline</mat-option>
        </mat-select>
      </mat-form-field>

      <button
        mat-stroked-button
        type="button"
        class="grid-refresh-btn"
        (click)="atualizarDados()"
        [disabled]="loadingGrid"
      >
        <mat-icon>refresh</mat-icon>
        Buscar novos dados
      </button>
    </div>

    <p-menubar [model]="items"></p-menubar>

    <div class="grid-table-wrapper">
      <p-table
        #gridTable
        [value]="rows"
        styleClass="grid-datatable"
        tableStyleClass="grid-table tableAnalitico"
        [lazy]="true"
        [loading]="loadingGrid"
        [paginator]="true"
        [rows]="tableRows"
        [first]="tableFirst"
        [totalRecords]="totalElements"
        [rowsPerPageOptions]="[10, 25, 50, 100]"
        [scrollable]="true"
        [scrollHeight]="gridScrollHeight"
        [responsive]="true"
        (onLazyLoad)="onLazyLoad($event)"
      >
        <ng-template pTemplate="header">
          <tr>
            <th>Motorista</th>
            <th>Empresa</th>
            <th>Placa</th>
            <th>Frota</th>
            <th>Localização</th>
            <th>Status</th>
            <th>Eventos</th>
            <th>Última mensagem</th>
            <th class="grid-th-data-posicao">
              <span class="grid-th-line">Data da posição</span>
              <span class="grid-th-sub">(Últimas posições)</span>
            </th>
            <th class="grid-th-mapa">Mapa</th>
          </tr>
        </ng-template>

        <ng-template pTemplate="body" let-row>
          <tr>
            <td>
              <span class="p-column-title">Motorista</span>
              {{ row.nmMotorista || "-" }}
            </td>
            <td>
              <span class="p-column-title">Empresa</span>
              {{ row.nomeEmpresa || "-" }}
            </td>
            <td>
              <span class="p-column-title">Placa</span>
              {{ row.placa || "-" }}
            </td>
            <td>
              <span class="p-column-title">Frota</span>
              {{ row.frota || "Frota não cadastrada" }}
            </td>
            <td class="grid-localizacao-cell">
              <span class="p-column-title">Localização</span>
              <span
                *ngIf="exibirEnderecoNoGrid && loadingEnderecos && !row.endereco"
                class="grid-endereco-loading"
                >Carregando endereço...</span>
              <span
                *ngIf="exibirEnderecoNoGrid && row.endereco"
                class="grid-endereco-text"
              >
                {{ row.endereco }}
              </span>
              <span
                *ngIf="
                  !exibirEnderecoNoGrid ||
                  (!loadingEnderecos && !row.endereco)
                "
                >-</span>
            </td>
            <td class="grid-status-cell">
              <span class="p-column-title">Status</span>
              <span
                class="grid-status-badge"
                [ngClass]="
                  row.statusLabel === 'Online'
                    ? 'grid-status-online'
                    : 'grid-status-offline'
                "
              >
                {{ row.statusLabel }}
              </span>
            </td>
            <td class="grid-eventos-cell">
              <span class="p-column-title">Eventos</span>
              {{ row.ultimoEvento || "-" }}
            </td>
            <td>
              <span class="p-column-title">Última mensagem</span>
              {{ formatDisplayDate(row.dataOnline) }}
            </td>
            <td>
              <span class="p-column-title">Data da posição</span>
              {{ formatDisplayDate(row.dataAtualizacao) }}
            </td>
            <td class="grid-mapa-cell">
              <span class="p-column-title">Mapa</span>
              <span
                class="alerta"
                matTooltip="Visualizar no mapa"
                *ngIf="row.latitude && row.longitude"
              >
                <a class="btn btn-link" (click)="openMap(row)">
                  <img
                    height="15"
                    src="assets/img/view.svg"
                    alt="Abrir mapa"
                  />
                </a>
              </span>
              <span *ngIf="!(row.latitude && row.longitude)">-</span>
            </td>
          </tr>
        </ng-template>

        <ng-template pTemplate="emptymessage">
          <tr>
            <td colspan="10">
              Nenhum veículo encontrado para o perfil selecionado.
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
</div>
